<template>
  <div class="tw-flex tw-flex-col tw-flex-1">
    <div v-if="isLoading" class="custom-global-skeleton tw-w-full tw-h-full" />
    <div v-else class="tw-p-[20px]">
      <div class="tw-flex">
        <div class="impact-item">
          <div class="number-lable">4</div>
          <div class="text-lable">
            {{
              getComponentUiText(
                "app-dashboard-cyber-health-rise-assessment-impact-text-1",
              )
            }}
          </div>
          <div class="number-lable">0</div>
        </div>
        <div class="grid-container">
          <div
            v-for="(item, rowIndex) in moreDetail"
            :key="rowIndex"
            class="grid-item"
          >
            <div
              v-for="(col, colIndex) in item.gridItem"
              :key="colIndex"
              class="grid-item-inner"
              :class="`${col.number ? col.className : 'negligible'}`"
            >
              <div v-if="col.number" class="grid-item-number">
                {{ col.number }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="likelihood-item">
        <div class="number-lable">0</div>
        <div class="text-lable">
          {{
            getComponentUiText(
              "app-dashboard-cyber-health-rise-assessment-likelihood-text-1",
            )
          }}
        </div>
        <div class="number-lable">4</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import store from "@/store";
import { getComponentUiText, processingRiskValue } from "@/utils/utilities";
import {
  arrayDataRiskAssessmentDefault,
  dummyDataRiskAssessment,
} from "@/utils/constants";
import { onMounted } from "vue";

const checklistGroupMetrics = computed(
  () => store.getters["Recommend/getChecklistGroupMetrics"],
);

const isHaveData = computed(() => {
  return Object.keys(checklistGroupMetrics.value).length;
});

const moreDetail: any = ref(arrayDataRiskAssessmentDefault);
const props = defineProps({
  loading: {
    type: Boolean,
    required: false,
  },
});
const isLoading = ref(props.loading);

watch(
  () => props.loading,
  (newVal) => {
    isLoading.value = newVal;
  },
);

onMounted(async () => {
  if (isHaveData.value) {
    moreDetail.value = await processingRiskValue(checklistGroupMetrics.value);
  } else {
    moreDetail.value = dummyDataRiskAssessment;
  }
});

watch(
  () => checklistGroupMetrics.value,
  async (newVal) => {
    if (isHaveData.value) {
      moreDetail.value = await processingRiskValue(newVal);
    } else {
      moreDetail.value = dummyDataRiskAssessment;
    }
  },
);
</script>

<style scoped lang="scss">
.default {
  background: var(--ui-white, #fff);
  color: var(--ui-dark-grey, #878787);
  border-radius: 4px;
  border: 1px solid var(--ui-rule, #eff0f1);
}

.grid-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 6px;
  .grid-item {
    display: flex;
    flex-direction: row;
    min-height: 41px;
    gap: 6px;
    .grid-item-inner {
      width: 20%;
      height: 100%;
      border-radius: 1px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1 0 0;
      align-self: stretch;
      .grid-item-number {
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
      }
    }
  }
}
.impact-item {
  display: flex;
  padding: 18px 0px;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin-right: 20px;
  .text-lable {
    transform: rotate(-90deg);
    width: 8px;
  }
}
.text-lable {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.number-lable {
  color: var(--UI-dark-grey, #878787);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
}
.likelihood-item {
  display: flex;
  padding: 0px 23px 0px 52px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding-top: 20px;
  .text-lable {
    height: 8px;
  }
}
.negligible {
  background: var(--UI-rule-50, rgba(239, 240, 241, 0.5));
}
.low {
  background: var(--UI-green-soft, #d9ede2);
  .grid-item-number {
    color: var(--Brand-Green, #01893d);
  }
}
.medium {
  background: var(
    --placeholder-orange-soft,
    linear-gradient(
      0deg,
      rgba(254, 154, 5, 0.15) 0%,
      rgba(254, 154, 5, 0.15) 100%
    ),
    #fff
  );
  .grid-item-number {
    color: var(--placeholder-orange, #fe9a05);
  }
}
.high {
  background: var(--UI-red-orange-soft, #fee5e2);
  .grid-item-number {
    color: var(--Brand-Red-Orange, #f7553c);
  }
}
</style>
